import { freddyTheme as theme, type SxProps } from '@coolblue-development/freddy';
import type { CSSProperties } from 'react';

const opacity = theme.opacity;
const { fast } = theme.motionDuration;
const { easeInOut } = theme.motionEasing;
const fastEaseInOut = `${fast} ${easeInOut}`;

const container: SxProps = {
  width: '100%',
  position: 'relative',

  'input[type="checkbox"]:not(:checked)': {
    '--cb-switch-color-background-container':
      'var(--cb-color-background-interactive-control-contrast-hovered)'
  }
};

const icon: SxProps = {
  '@keyframes revealOpacity': {
    to: { opacity: 1 }
  },
  '@keyframes drawCheckmark': {
    to: { strokeDashoffset: 0 }
  },
  svg: {
    animation: `revealOpacity 0.25s ${easeInOut} forwards`,
    gridArea: '1 / 1',
    opacity: opacity.transparent
  }
};

const checkmarkPath: CSSProperties = {
  animation: `drawCheckmark ${fastEaseInOut} forwards`,
  animationDelay: '.15s',
  strokeDasharray: 20,
  strokeDashoffset: 20
};

const accessorySummary: SxProps = {
  gridRow: 2,
  gridColumn: '1 / span 2',
  opacity: opacity.full,

  button: {
    fontWeight: theme.typography.fontWeight.openSans.normal,
    minHeight: 0
  }
};

export default {
  container,
  icon,
  checkmarkPath,
  accessorySummary
};
